module.exports = __webpack_public_path__ + "static/media/deposited_outline.ef819d56.png";